import React from "react";
import { Dropdown, DropdownItem } from "flowbite-react";
import { IoMdArrowDropdown } from "react-icons/io";
import { LiaFontSolid } from "react-icons/lia";
import { TbBackground } from "react-icons/tb";
const customColors = [
  // blue shades
  ["#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],

  // green shades
  ["#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],

  // orange shades
  ["#fee0b6", "#fdb863", "#e08214", "#b35806", "#7f3b08"],

  // gray shades
  ["#ffffff", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],

  // brown shades
  ["#f6e8c3", "#dfc27d", "#bf812d", "#8c510a", "#543005"],

  // purple shades
  ["#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],

  // red shades
  ["#fddbc7", "#f4a582", "#d6604d", "#b2182b", "#67001f"],

  // blue-gray shades (around #e5e7eb)
  ["#f9fafb", "#e5e7eb", "#d1d5db", "#9ca3af", "#6b7280"],
];

export default function SelectColor({
  ControllerProps,
  dispatchItemToredux,
  color,
  colorSetter,
  setColor,
  setBackgroundColor,
  textColor,
  backgroundColor,
  defaultValue: reduxColorValue,
  colorType,
}) {
  // console.log(ControllerProps);
  const { defaultValue } = ControllerProps
    ? ControllerProps
    : { defaultValue: "#000000" };
  const colorValue = reduxColorValue ?? defaultValue;
  // console.log(colorValue);
  const handleColorChange = (color) => {
    if (colorSetter === "bgColor") {
      setBackgroundColor(color);
    } else {
      setColor(color);
    }
  };
  return (
    <div className="w-full items-center justify-between gap-0 font-light flex text-sm">
      {ControllerProps === undefined ? null : ControllerProps.title}
      <Dropdown
        label={
          <div className="w-full flex items-center justify-center gap-1 text-black font-light border px-1 rounded py-[2px]">
            {colorSetter === undefined ? (
              <button className="flex flex-col items-center justify-center gap-0 text-base font-light">
                {colorType === "bg" ? (
                  <TbBackground />
                ) : colorType === "text" ? (
                  <LiaFontSolid />
                ) : (
                  <LiaFontSolid />
                )}
                <span
                  style={{
                    backgroundColor:
                      color !== undefined && color !== null ? color : "black",
                  }}
                  className="font-UberMoveTextMedium w-4 h-[0.2rem]"
                ></span>
              </button>
            ) : colorSetter === "bgColor" ? (
              <button
                style={{
                  backgroundColor:
                    backgroundColor !== undefined &&
                    backgroundColor !== null &&
                    backgroundColor,
                  color:
                    textColor !== undefined && textColor !== null && textColor,
                }}
                className="flex flex-col items-center justify-center gap-0 text-base font-light w-[5.5rem] py-[2px] rounded"
              >
                Cell Color
              </button>
            ) : (
              <button className="flex flex-col items-center justify-center gap-0 text-base font-light">
                A
                <span
                  style={{
                    backgroundColor: textColor
                      ? textColor
                      : colorValue || "#000000",
                  }}
                  className="font-UberMoveTextMedium w-4 h-[0.2rem]"
                ></span>
              </button>
            )}
            <IoMdArrowDropdown className="text-xl text-black" />
          </div>
        }
        arrowIcon={false}
        className="w-auto flex flex-col items-center justify-start absolute top-0 left-0"
        placement="bottom"
      >
        {customColors.map((colorRow, rowIndex) => (
          <div key={rowIndex} className=" p-1 items-center justify-center flex">
            {colorRow.map((color, colorIndex) => (
              <DropdownItem
                key={colorIndex}
                onClick={() =>
                  ControllerProps
                    ? dispatchItemToredux(color, ControllerProps.reduxKey)
                    : handleColorChange(color)
                }
                style={{
                  backgroundColor: color,
                  width: "20px",
                  height: "20px",
                }}
                className={`border border-gray-200 `}
              />
            ))}
          </div>
        ))}
      </Dropdown>
    </div>
  );
}
